import React, { useState, useEffect, useLayoutEffect, lazy } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import _ from "lodash";
import { ToastContainer } from "react-toastify";

// constants

// actions
import { deviceSize } from "./actions";

// components
import MainApp from "./MainApp";
import Login from "./Login";
import FourZeroFour from "./FourZeroFour";
import Plan from "./components/plan";
import UserList from "./components/userlist";
import UserDetails from "./components/userlist/userdetails";
import AddCredit from "./components/userlist/addcredits";
import UpdatePlan from "./components/userlist/updateplan";
import ReportedContact from "./components/reportedcontact";
// files

const App = (props) => {
  const { deviceSizeReducer, isLoggedIn, session } = props;

  useEffect(() => {}, []);

  useLayoutEffect(() => {
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  const updateSize = () => {
    if (window.innerWidth < 576) {
      props.deviceSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: true,
      });
    } else if (window.screen.width < 576) {
      props.deviceSize({
        width: window.screen.width,
        height: window.screen.height,
        isMobile: false,
      });
    } else {
      props.deviceSize({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobile: false,
      });
    }
  };

  return (
    <>
      <Router basename={"/"}>
        {/* <Router> */}
        <Routes>
          {/* Every component inside / route follows MainApp layout, hence grouped together */}
          <Route path="/" element={<MainApp />}>
            <Route path="plan" element={<Plan />} />
            <Route path="userlist" element={<UserList />} />
            <Route path="userdetails/:id" element={<UserDetails />} />
            <Route path="addcredit/:id" element={<AddCredit />} />
            <Route path="updateplan/:id" element={<UpdatePlan />} />
            <Route path="reportedcontacts" element={<ReportedContact />} />
          </Route>
          {/* /login, /404 is single full page, diff than MainApp layout so kept outside */}
          <Route path="/login" element={<Login />} />
          {/* <Route path="/404" element={<FourZeroFour />} /> */}
          {/* Mandatory * route, to deal with any myslenious route attempts /login125 */}
          {/* <Route path="*" element={<FourZeroFour />} /> */}
        </Routes>
      </Router>
      <ToastContainer theme="dark" />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    isLoggedIn: state.isLoggedIn,
    deviceSizeReducer: state.deviceSize,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      deviceSize,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(App);
